export const typeStyles = {
  success: {
    bg: "bg-green-50",
    border: "border-green-200",
    title: "text-primary",
    icon: "text-green-500",
  },
  info: {
    bg: "bg-blue-50",
    border: "border-blue-200",
    title: "text-blue-700",
    icon: "text-blue-500",
  },
  error: {
    bg: "bg-red-50",
    border: "border-red-200",
    title: "text-red-700",
    icon: "text-red-500",
  },
  warning: {
    bg: "bg-yellow-50",
    border: "border-yellow-200",
    title: "text-yellow-700",
    icon: "text-yellow-500",
  },
};

export const unreadStyles = {
  container: "border-l-4 border-l-blue-500 bg-blue-50/30 shadow-md",
  title: "font-bold",
  indicator: "bg-blue-500 animate-pulse",
  badge: "bg-blue-100 text-blue-700",
  hover: "hover:bg-blue-50/50 hover:shadow-lg",
}; 